import axios from "axios";
import authHeader from '../../../authheader'

const EIAPPLICATIONURL = process.env.REACT_APP_APIURL + "/api/IndividualEiReinstatement";



const getBoardRecommendations = (reinstatementId) => {
    return axios.get(`${EIAPPLICATIONURL}/boardrecommendations`, { headers: authHeader(), params: { reinstatementId } });
}
const getBoardResponses = (reinstatementId) => {
    return axios.get(`${EIAPPLICATIONURL}/boardmemberresponses`, { headers: authHeader(), params: { reinstatementId } });
}
const postBoardRecommendation = (data) => {
    return axios.post(`${EIAPPLICATIONURL}/boardrecommendation`, data, { headers: authHeader() });
}
const postBoardResponse = (data) => {
    var header = authHeader();
    header['Content-Type'] = 'multipart/form-data';
    return axios.post(`${EIAPPLICATIONURL}/boardmemberresponse`, data, { headers: { ...header } });
}
export default {
    getBoardRecommendations,
    getBoardResponses,
    postBoardRecommendation,
    postBoardResponse
}